import { logOutAction } from '@/redux/slices/user.slice';
import { store } from '@/redux/store';
import axios from 'axios';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';

export const BASE_URL = process.env.REACT_APP_API_BASEURL;

const axiosClient = axios.create({
  baseURL: `${BASE_URL}/api/cms`,
  headers: {
    'Content-Type': 'application/json',
  },
  // commented due to CORS
  // withCredentials: true,
});

axiosClient.interceptors.request.use(async (config) => {
  if (!config.data) config.data = {};
  if (config.data) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${Cookies.get('access_token') || ''}`,
    };
  }

  return config;
});

axiosClient.interceptors.response.use(
  (response) => response.data || response,
  async (error) => {
    const err = error.response || error;
    if (err.status === 401) {
      // store.dispatch(logOutAction());
      toast.info('Your session has expired. Please log in again.', {
        hideProgressBar: true,
        autoClose: 6000,
      });
      store.dispatch(logOutAction());

      // redirect to login page
      throw err;
    }
    throw err;
  }
);

export default axiosClient;
